import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * @param {Object} props
 * @param {Object} props.session
 * @param {{top: number, left: number}} props.position
 * @param {boolean} props.isMine
 * @param {Function} props.onRename
 * @param {Function} props.onShare
 * @param {Function} props.onArchive
 * @param {Function} props.onDelete
 * @param {Function} props.onClose
 */
export const SessionContextMenu = ({ session, position, isMine, onRename, onShare, onArchive, onDelete, onClose }) => {
    const { t } = useTranslation();
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    // Ajustar posición si queda fuera de viewport
    useEffect(() => {
        if (menuRef.current) {
            const rect = menuRef.current.getBoundingClientRect();
            const el = menuRef.current;
            if (rect.bottom > window.innerHeight) {
                el.style.top = `${position.top - rect.height}px`;
            }
            if (rect.right > window.innerWidth) {
                el.style.left = `${position.left - rect.width}px`;
            }
        }
    }, [position]);

    const isArchived = session.is_archived;

    return (
        <div
            ref={menuRef}
            className="agent-context-menu"
            style={{ top: position.top, left: position.left }}
        >
            <button className="agent-context-menu__item" onClick={() => { onRename(session); onClose(); }}>
                <i className="fas fa-pencil-alt"></i>
                {t('agent_chat.session_menu_rename')}
            </button>
            <button className="agent-context-menu__item" onClick={() => { onShare(session); onClose(); }}>
                <i className="fas fa-share-alt"></i>
                {t('agent_chat.session_menu_share')}
            </button>
            <button className="agent-context-menu__item" onClick={() => { onArchive(session); onClose(); }}>
                <i className="fas fa-archive"></i>
                {isArchived ? t('agent_chat.session_menu_unarchive') : t('agent_chat.session_menu_archive')}
            </button>
            {isMine && (
                <button className="agent-context-menu__item agent-context-menu__item--danger" onClick={() => { onDelete(session); onClose(); }}>
                    <i className="fas fa-trash"></i>
                    {t('agent_chat.session_menu_delete')}
                </button>
            )}
        </div>
    );
};
